<!-- backtop -->
<template>
  <div class="">
    <img
      class="backtop"
      :src="require('@/assets/icon/backtop.png')"
      @click="backTop(50)"
      v-show="toTop"
    />
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      toTop: false, //是否显示回到顶部
      timer: null,
    };
  },
  computed: {},
  watch: {},
  methods: {
    // 展示
    handleScroll() {
      let top = document.documentElement.scrollTop || document.body.scrollTop;
      if (top > window.screen.height) {
        this.toTop = true;
      } else {
        this.toTop = false;
      }
    },
    // 回到顶部
    backTop(speed) {
      // 滚动到顶部
      let _this = this;
      //home-content为需要被滚动到顶部的元素
      //let element = document.body；
      let top = document.documentElement.scrollTop || document.body.scrollTop;
      this.timer = setInterval(function () {
        top -= speed;
        if (top <= 1) {
          top = 0;
          clearInterval(_this.timer);
        }
        document.documentElement.scrollTop = document.body.scrollTop = top;
      }, 20);
    },
  },
  created() {},
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  deactivated() {
    clearInterval(this.timer);
  },
};
</script>
<style lang='scss' scoped>
.backtop {
  position: fixed;
  bottom: 30px;
  right: 40px;
  color: #fff;
  background: #d7d7d7;
  border-radius: 50%;
  z-index: 200;
  width: 0.8rem;
}
</style>